export default {
  placesAndDirections: {
    'isochrones': 'Isocrone',
    'place': 'luogo',
    'notRouteFound': 'Non è stato possibile trovare un percorso con i luoghi selezionati per questo mezzo di trasporto',
    'notRouteFoundWithFilters': 'Non è stato possibile trovare un percorso con le impostazioni e luoghi scelti per questo mezzo di trasporto',
    'noPlaceFound': 'Nessun luogo trovato con i dati indicati',
    'routeReady': 'Trova e va',
    'useLocation': 'GPS',
    'addPlaceInput': 'Aggiungi luogo',
    'clearRoute': 'Cancella itinerario',
    'reverseRoute': 'Inverti',
    'orderByClosestPlaces': 'Ordina secondo luoghi più vicini alla tua posizione',
    'calculatingRoute': 'Calcolando itinerario...',
    'yourLocation': 'La mia posizione',
    'expandAltitudeChart': 'Ingrandisci mappa in altezza',
    'errorRenderingContentUploaded': 'Errore nel mostrare il contenuto scaricato. Verifica formato e contenuto',
    'roundTrip': 'Andata e ritorno',
    'notPossibleToCalculateRoute': 'Nessun itinerario trovato per i luoghi selezionati',
    'apiError': {
      '2000': 'Parse della richiesta JSON non possibile',
      '2001': 'Parametri obbligatori mancanti',
      '2002': 'Formato del parametro non valido',
      '2003': 'I parametri del percorso superano uno o più limiti. Ricorda che alcuni evitabili hanno dei limiti, come la lunghezza del percorso e l\'area di un poligono da evitare che non deve superare i 20000 chilometri quadrati.',
      '2004': 'I parametri del percorso superano uno o più limiti. Ricorda che la distanza approssimativa del percorso non deve essere superiore a 6000 km. Quando vengono utilizzate determinate opzioni di percorso o elementi da evitare, la distanza approssimativa del percorso non deve essere maggiore di 150 km.',
      '2006': 'Parse della richiesta all\'export handler non possibile',
      '2007': 'Formato per l\'esportazione non supportato',
      '2008': 'Elemento vuoto',
      '2009': 'Non è stato possibile trovare un percorso valido per i luoghi e criteri specificati. Il profile specificato potrebbe non essere supportato in questa area/regione con i filtri applicati.',
      '2010': 'Almeno un punto non è stato trovato. Forse il punto selezionato non è accessibile o il mezzo di trasporto scelto non è supportato in questa regione',
      '2011': 'Parametro incompatibile',
      '2012': 'Un parametro non valido è stato specificato.',
      '2099': 'Non è stato possibile trovare un punto valido dopo 3 tentativi'
    },
    'genericErrorMsg': 'Non è stato possibile calcolare un percorso',
    'reorder': 'Riordina'
  }
}
